<template>
  <div class="register-page-shell">
    <div class="register-box mx-auto">
      <div class="register-brand text-center">
        <p class="register-brand__eyebrow mb-1">AGS BP Batam</p>
        <h1 class="register-brand__title mb-0">Create Account</h1>
        <p class="register-brand__subtitle mb-0">Fill in the form below to join the system.</p>
      </div>

      <div class="card register-card shadow-sm">
        <div class="card-body register-card-body">
          <p class="register-card__message">Register your membership here</p>
          <RegistrationForm @registered="goToLogin"/>
          <p class="mt-3 mb-0 text-center register-card__footer">
            <b-link :to="{name: 'Login'}">
              Already a member? Log In Now!
            </b-link>
          </p>
        </div>
      </div>
    </div>
    <!-- Credential Modal -->
    <b-modal centered header-bg-variant="success" id="credential" size="sm" title="Keep this password"
             ok-only
             no-close-on-esc
             hide-header-close
             no-close-on-backdrop>
      <h4>Please save this Password</h4>
      <h1 class="text-center">{{ password }}</h1>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="password=null;cancel();$router.replace({ name: 'Login' })">
          OK!
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue';
import RegistrationForm from "@/views/Members/RegistrationForm";
export default {
  name: "Register",
  components: {
    RegistrationForm,
    BLink,
  },
  data: () => ({
    password: null,
  }),
  created() {
    document.body.className = 'register-page';
  },
  methods: {
    goToLogin({user}){
      this.password = user.paswd;
      this.$bvModal.show('credential')
    },
  },
}
</script>

<style scoped>
  :global(body.register-page) {
    margin: 0;
    min-height: 100vh;
    overflow-x: hidden;
    background:
      radial-gradient(circle at top, rgba(255, 191, 0, 0.12), transparent 30%),
      radial-gradient(circle at bottom right, rgba(2, 53, 110, 0.16), transparent 35%),
      linear-gradient(180deg, #f7f9fc 0%, #eef3f9 100%);
  }

  .register-page-shell {
    min-height: 100vh;
    padding: 28px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .register-box {
    width: min(100%, 560px);
  }

  .register-brand {
    margin-bottom: 18px;
    padding: 0 8px;
    color: #0f172a;
  }

  .register-brand__eyebrow {
    font-size: 0.8rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #6b7280;
    font-weight: 700;
  }

  .register-brand__title {
    font-size: clamp(1.8rem, 4vw, 2.4rem);
    font-weight: 800;
    line-height: 1.1;
    margin-top: 6px;
  }

  .register-brand__subtitle {
    margin-top: 8px;
    font-size: 0.98rem;
    color: #64748b;
  }

  .register-card {
    border: 0;
    border-radius: 24px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 20px 60px rgba(15, 23, 42, 0.08);
  }

  .register-card-body {
    padding: 28px;
  }

  .register-card__message {
    margin-bottom: 18px;
    color: #334155;
    font-size: 1rem;
    font-weight: 600;
  }

  .register-card__footer a {
    color: #0f172a;
    font-weight: 600;
    text-decoration: none;
  }

  .register-card__footer a:hover {
    text-decoration: underline;
  }

  @media (max-width: 576px) {
    .register-page-shell {
      padding: 18px 12px;
      align-items: flex-start;
    }

    .register-brand {
      margin-bottom: 14px;
      text-align: left !important;
    }

    .register-card-body {
      padding: 20px 16px;
    }
  }
</style>
